import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Spin, Row, Col, Input, Button, Modal, Form, Layout, DatePicker, Select, Table } from 'antd'
import {salesmanList, agentDetail, auditUser} from '_src/api/api'
import './salesman.less'

const { Search } = Input

const { RangePicker } = DatePicker
const { Option } = Select
const ColProps = {
  xs: 24,
  sm: 12,
  style: {
    marginBottom: 16,
  },
}

class Salesman extends PureComponent {

  constructor () {
    super()
    this.state = {
      isLoading: false,
      modelVisible: false,

      pageData: {
        total: 0, 
        current: 1, 
      },

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      list: [],

      columns: [
        {
          title: <span>用户账号</span>,
          align: 'center',
          dataIndex: 'user',
          render: user => <span>{user.mobile}</span>
        },
        {
          title: <span>用户姓名</span>,
          align: 'center',
          dataIndex: 'agentName',
        },
        {
          title: <span>订单数量</span>,
          dataIndex: 'orderCount',
          align: 'center',
        },
        {
          title: <span>总流水</span>,
          dataIndex: 'commissionSum',
          align: 'center',
        },
        {
          title: <span>状态</span>,
          align: 'center',
          render: item => item.status === 0 ? <span>待审核</span> : (item.status === 1 ? <span style={{color: '#1f922c'}}>已通过</span> : <span style={{color: '#ff4447'}}>已拒绝</span>)
        },
        {
          title: <span>创建时间</span>,
          dataIndex: 'createAt',
          align: 'center',
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => (
            item.status === 0 ? <Button icon="filter" type="primary" onClick={() => { this.look(item.id) }}>审核</Button> : <Button icon="eye" onClick={() => { this.look(item.id) }}>查看</Button>
          )
        },
      ]
    
    }
  }

  componentDidMount () {
    const {params} = this.state
    this.loadList(params)
  }

  loadList = (params) => {
    this.setState({isLoading: true})
    salesmanList(params)
      .then(res => {
        this.setState({
          isLoading: false,
          list: res.data.content,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
  }

  // 审核/查看
  look = (id) => {
    agentDetail({id})
      .then(res => {
        this.setState({
          info: res.data,
          modelVisible: true,
        })
      })
  }

  // 提交审核 
  audit = (id, status) => {
    auditUser({id, status})
      .then(res => {
        if (res) {
          this.setState({
            modelVisible: false,
            info: '',
          }) 
          this.loadList(this.state.params)
        }
      })
  }

  // 审核页面元素
  genModal (info) {
    return (
      <Form onSubmit={this.handleSubmit} className="discount-form">
        <Form.Item label="姓名：" className='flex'>
          <Input value={info.agentName} style={{width: 178}} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="性别：" className='flex'>
          <Input value={info.sex === 1 ? '男' : '女'} style={{width: 178}} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="联系方式：" className='flex'>
          <Input value={info.contact} style={{width: 178}} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="居住地：" className='flex'>
          <Input value={info.residence} style={{width: 178}} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        <Form.Item label="职业：" className='flex'>
          <Input value={info.job} style={{width: 178}} min={1} max={10} readOnly="readonly" />
        </Form.Item>
        {
          info.status === 0 
            ? <Form.Item>
              <Button type="primary" htmlType="submit" icon='check' style={{width: 100, marginLeft: 50}} onClick={()=>{ this.audit(info.id, 1) }}>通过</Button>
              <Button htmlType="submit" icon='close' style={{width: 100, marginLeft: 20}} onClick={()=>{ this.audit(info.id, 2) }}>不通过</Button>
            </Form.Item>
            : ''
        }
      </Form>
    )
  }
  
  // 分页
  onPageChange = (e) => {
    const {params} = this.state
    params.pageNum = e.current - 1
    this.setState({params})
    this.loadList(params)
  }

  // 时间筛选
  timerChange = (e) => {
    const {params} = this.state
    if (e.length) {
      params.registerStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
      params.registerEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    } else {
      delete params.registerStart
      delete params.registerEnd
    }
    params.pageNum = 0
    this.setState({params})
    this.loadList(params)
  }
  
  // 搜索
  onSearch = (e) => {
    console.log(e)
    const {params} = this.state
    if (e.length) {
      params.account = e
    } else {
      delete params.account
    }
    this.setState({params})
    this.loadList(params)
  }
  // 状态
  onSelect = (e) => {
    const {params} = this.state
    if (e) {
      params.status = e
    } else {
      delete params.status
    }
    this.setState({params})
    this.loadList(params)
  }

  render () {
    const {isLoading, columns, list, info, modelVisible, pageData} = this.state
    return (
      <Layout className="salesman-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <div className='filter-inner'>
          <Row>
            <Col {...ColProps} xl={{ span: 6}} md={{ span: 8 }} style={{ width: 240 }} className="flex-h-a">
              <span >审核状态：</span>
              <Select defaultValue="" style={{ width: 120 }} onChange={this.onSelect}>
                <Option value="">全部</Option>
                <Option value="0">待审核</Option>
                <Option value="1">已通过</Option>
                <Option value="2">未通过</Option>
              </Select>
            </Col>
            <Col {...ColProps} xl={{ span: 8}} md={{ span: 8 }} className="flex-h-a">
              <span >注册时间：</span>
              <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
            </Col>
            <Col {...ColProps} xl={{ span: 8}} md={{ span: 8 }} className="flex-h-a">
              <span >用户账号：</span>
              <Search style={{ width: 250 }} placeholder="用户账号" onSearch={this.onSearch} enterButton />
            </Col>
          </Row>
          {
            !isLoading && (
              <Table
                columns={columns}
                dataSource={list}
                bordered
                rowKey="id"
                pagination={{
                  current: pageData.current,
                  total: pageData.total, 
                  pageSize: pageData.pageSize,
                }} 
                onChange={this.onPageChange}
              />
            )
          }

          <Modal
            title="分销人员"
            visible={modelVisible}
            onCancel={()=>{
              this.setState({ 
                modelVisible: false,
                info: '',
              })  
            }}
            width={400}
            footer={false}
            destroyOnClose
          >
            {info ? this.genModal(info) : ''}
          </Modal>


        </div>
      </Layout>
    )
  }
}

export default connect()(Salesman)